import React, { createContext, useContext, useState, ReactNode } from 'react';

type BillingContextType = {
    activeTab: number;
    setActiveTab: (active: number) => void;
};

const BillingContext = createContext<BillingContextType | undefined>(undefined);

export const BillingProvider = ({ children }: { children: ReactNode }) => {
    const [activeTab, setActiveTab] = useState(0);
    

    return (
        <BillingContext.Provider
            value={{
                setActiveTab,
                activeTab
            }}
        >
            {children}
        </BillingContext.Provider>
    );
};

export const useBilling = () => {
    const context = useContext(BillingContext);
    if (!context) {
        throw new Error('useBilling must be used within a BillingProvider');
    }
    return context;
};